'use strict';

const experiments = {
  newPopularStores: {
    key: 'coupons->showNewPopularStores',
    customMetric: 'coupons-click-popular-stores-homepage',
  },
  emailCTAHomepageRedemptions: {
    key: 'coupons->showNewHomepageEmailCTAPlacementRedemptions',
    customMetric: 'coupons-redemption',
  },
  emailCTAMerchantPageRedemptions: {
    name: 'emailCTAMerchantPageRedemptions',
    key: 'coupons->showNewMerchantEmailCTAPlacementRedemptions',
    customMetric: 'coupons-merchant-redemption',
  },
};

module.exports = { experiments };
